import React from "react";
import {FlatList, Modal, TextInput, TouchableOpacity, View} from "react-native";
import AppText from "./AppText";
import ISubClient from "../Models/Client/ISubClient";

interface IProps {
    show: boolean;
    onClose: Function;
    data: ISubClient[];
    onChange: Function;
}

export default class SubClientsSelectionModal extends React.Component<IProps> {
    state = {
        filter: '',
    };

    componentDidUpdate(prevProps: Readonly<IProps>) {
        if (this.props.show != prevProps.show && this.props.show) {
            this.setState({filter: ''});
        }
    }

    getData() {
        if (this.state.filter != '') {
            return this.props.data.filter(d => d.name.startsWith(this.state.filter));
        }
        return this.props.data;
    }

    render() {
        return (
            <Modal visible={this.props.show} transparent={true}>
                <View style={{width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignItems: 'center'}}>
                    <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => this.props.onClose()}
                        style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}
                    />
                    <View style={{width: '85%', height: '70%', backgroundColor: '#fff', shadowColor: '#8c8c8c', borderRadius: 5, shadowOpacity: 0.7, shadowOffset: {width: 1, height: 2}, zIndex: 1}}>
                        <View style={{flex: 0.9, width: '100%'}}>
                            <TextInput
                                value={this.state.filter}
                                onChangeText={text => this.setState({filter: text})}
                                style={{marginBottom: 10, width: '100%', height: 40, backgroundColor: '#01B271', paddingRight: 15, paddingLeft: 15, textAlign: 'right', color: '#fff', fontSize: 16, fontWeight: '500'}}
                                placeholderTextColor={'#efefef'}
                                placeholder={'חפש כאן..'}
                                autoCorrect={false}
                            />
                            <FlatList
                                keyboardShouldPersistTaps="handled"
                                data={this.getData()}
                                keyExtractor={(item, index) => String(item.id ?? index)}
                                renderItem={({item}) => (
                                    <TouchableOpacity
                                        onPress={() => this.props.onChange(item.id)}
                                        style={{width: '100%', backgroundColor: item.isSelected ? '#01B271' : 'white', paddingTop: 10, paddingBottom: 10, paddingLeft: 15, paddingRight: 15, borderBottomWidth: 1, borderBottomColor: '#a7a7a7'}}>
                                        <AppText style={{fontSize: 15, fontWeight: '500', textAlign: 'left', color: item.isSelected ? 'white' : 'black'}}>
                                            {item.name}
                                        </AppText>
                                    </TouchableOpacity>
                                )}
                            />
                        </View>
                        <View style={{flex: 0.1, width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around'}}>
                            <TouchableOpacity
                                onPress={() => this.props.onClose()}
                                style={{width: '90%', height: '60%', borderRadius: 3, backgroundColor: '#666666', alignItems: 'center', justifyContent: 'center'}}>
                                <AppText style={{color: 'white', fontWeight: '700', fontSize: 15}}>סגור</AppText>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </Modal>
        );
    }
}
